import { FC, HTMLAttributes, PropsWithChildren, ReactNode, useState } from 'react';
import { useCollapse } from 'react-collapsed';

type CollapsableElementProps = HTMLAttributes<HTMLDivElement> & {
  titleRenderer: (isExpanded: boolean) => ReactNode;
};

const CollapsableElement: FC<PropsWithChildren<CollapsableElementProps>> = ({ titleRenderer, children, ...props }) => {
  const [isExpanded, setExpanded] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  return (
    <div {...props}>
      <div
        {...getToggleProps({
          onClick: () => setExpanded((prevExpanded) => !prevExpanded),
        })}>
        {titleRenderer(isExpanded)}
      </div>
      <div {...getCollapseProps()}>{children}</div>
    </div>
  );
};

export default CollapsableElement;
